import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { i18n } from '@/locale/index';



const { t } = i18n.global;



const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    meta: {
      title: 'payment',
    },
    component: () => import('../views/payment/index.vue'),
  },
  {
    path: '/payment/success',
    name: 'payment-success',
    meta: {
      title: 'Payment Success',
    },
    component: () => import('../views/payment/success.vue'),
  },
  {
    path: '/payment/timeout',
    name: 'payment-timeout',
    meta: {
      title: 'Payment Timeout',
    },
    component: () => import('../views/payment/timeout.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/notFound/notfound.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name:'notfound',
    redirect:'/404'
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


router.beforeEach((to:any, from:any) => {
  document.title = to.meta.title ? to.meta.title : 'index';
});

export default router
